import { PowerSupplyPictogram } from './PowerSupplyPictogram';

export type PowerSupplyPictogramNotIncludedProps = {
  width?: string;
};

export const PowerSupplyPictogramNotIncluded = ({
  width,
}: PowerSupplyPictogramNotIncludedProps) => (
  <PowerSupplyPictogram width={width} type="NotIncluded" />
);
